module.exports = __webpack_public_path__ + "static/media/DemNow.a01fa948.jpg";